<div class="custom-404">
    <div class="alert alert-danger" role="alert">Oops!!! The resource you are looking for cannot be found.</div>
</div>
